import { NewsItem } from "./types";
import {
  LineChart,
  Smartphone,
  Handshake,
  BookOpen,
  Languages,
  Heart,
  Globe,
  CalendarCheck,
} from "lucide-react";

export const newsItems: NewsItem[] = [
  {
    id: 10,
    category: "press",
    title: "デジタル名刺「Share」ホワイトラベルパートナー募集開始",
    date: "2026.03.27",
    icon: Handshake,
    color: "orange",
    excerpt:
      "自社ブランドのデジタル名刺サービスを初期費用・在庫リスクゼロで立ち上げられるホワイトラベルプランの提供を開始しました。印刷業・広告代理店・IT企業の新規事業に最適です。",
    tags: ["パートナー", "ホワイトラベル", "デジタル名刺", "新規事業"],
    detailPath: "/news/share-whitelabel",
  },
  {
    id: 11,
    category: "press",
    title: "漢字名命名アプリ「Your Kanji Name」リリース",
    date: "2026.03.15",
    icon: Languages,
    color: "blue",
    excerpt:
      "外国人の性格や人生観を質問から導き出し、最もふさわしい漢字名を授けるWebアプリをリリース。音の当て字で無理やり漢字にする従来サービスとは一線を画す、意味から選ぶ新しいアプローチです。",
    tags: ["新サービス", "漢字", "Webアプリ", "インバウンド"],
    detailPath: "/news/kanjiname-release",
  },
  {
    id: 12,
    category: "press",
    title: "顧客管理アプリ「RINEちゃん」リリース",
    date: "2026.02.10",
    icon: Heart,
    color: "purple",
    excerpt:
      "キャバクラ・ガールズバーで働く女性のための専用顧客管理アプリをリリース。LINE連絡の記録、来店履歴・売上管理、リマインダー機能でお客様との関係性を向上させます。",
    tags: ["新サービス", "顧客管理", "モバイルアプリ"],
    detailPath: "/news/rinechan-release",
  },
  {
    id: 9,
    category: "press",
    title: "電子書籍出版代行サービス「著力（ちょりょく）」リリース",
    date: "2026.01.31",
    icon: BookOpen,
    color: "green",
    excerpt:
      "経営者・専門家向けの電子書籍出版代行サービスを開始しました。取材から原稿作成、表紙デザイン、Kindle出版手続きまでワンストップで対応。55,000円〜、最短2週間で出版可能です。",
    tags: ["新サービス", "出版代行", "Kindle", "ブランディング"],
    detailPath: "/news/choryoku-release",
  },
  {
    id: 13,
    category: "press",
    title: "LP制作「不用品回収メイプル」",
    date: "2025.12.23",
    icon: Globe,
    color: "orange",
    excerpt:
      "不用品回収サービス「メイプル」のランディングページを制作しました。",
    tags: ["LP制作", "Web制作"],
    link: "https://huyouhinmaple-hiroshima.com/",
  },
  {
    id: 8,
    category: "press",
    title: "ゴルフ上達アプリ「上手くなる気がするぅぅぅ」正式リリース",
    date: "2025.10.25",
    icon: LineChart,
    color: "green",
    excerpt:
      "ショット精度を可視化し、傾斜やクラブ別の分析でゴルフ上達をサポートする新アプリをリリースしました。実戦データから本当の課題を発見できます。",
    tags: ["新サービス", "ゴルフ", "スポーツテック", "モバイルアプリ"],
    detailPath: "/news/kigasuru-release",
  },
  {
    id: 7,
    category: "press",
    title: "デジタル名刺サービス「Share」正式リリース",
    date: "2025.06.01",
    icon: Smartphone,
    color: "blue",
    excerpt:
      "複数のSNSアカウントを一元管理できる次世代デジタル名刺サービス「Share」を正式リリースしました。QRコードでワンタッチ共有を実現。",
    tags: ["新サービス", "デジタル名刺", "SNS"],
    detailPath: "/news/share-release",
  },
  {
    id: 14,
    category: "press",
    title: "日程調整アプリ「アワセル」リリース",
    date: "2025.05.15",
    icon: CalendarCheck,
    color: "blue",
    excerpt:
      "登録不要・完全無料の日程調整アプリをリリース。URLを共有するだけで誰とでも日程調整ができます。広告なし・シンプルUIで快適な操作性を実現。",
    tags: ["新サービス", "日程調整", "無料", "Webアプリ"],
    detailPath: "/news/awaseru-release",
  },
];
